import { render, staticRenderFns } from "./MotoUpdate.vue?vue&type=template&id=0c390328&scoped=true&"
import script from "./MotoUpdate.vue?vue&type=script&lang=js&"
export * from "./MotoUpdate.vue?vue&type=script&lang=js&"
import style0 from "./MotoUpdate.vue?vue&type=style&index=0&id=0c390328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c390328",
  null
  
)

component.options.__file = "MotoUpdate.vue"
export default component.exports